(function() {
  const STORAGE_KEY = 'ezshop_exit_popup_dismissed_time';
  const COOLDOWN_HOURS = 24;

  function hasSeenRecently() {
    try {
      const lastSeen = localStorage.getItem(STORAGE_KEY);
      if (!lastSeen) return false;
      const hoursSince = (Date.now() - parseInt(lastSeen, 10)) / (1000 * 60 * 60);
      return hoursSince < COOLDOWN_HOURS;
    } catch (e) {
      return false;
    }
  }

  function markAsSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (e) {}
  }

  function initExitPopup() {
    const popup = document.getElementById('tshirt-exit-popup');
    if (!popup) return;

    let hasTriggered = false;

    function showPopup() {
      if (hasTriggered || hasSeenRecently()) return;
      hasTriggered = true;
      markAsSeen();

      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    // 1. Mouse Leave Intent (Desktop)
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 15) {
        showPopup();
      }
    });

    // 2. Global Event Delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-exit-popup-close]')) {
        e.preventDefault();
        hidePopup();
        return;
      }

      // Copy Coupon Code
      const copyBtn = e.target.closest('[data-copy-coupon]');
      if (copyBtn) {
        e.preventDefault();
        const codeEl = popup.querySelector('[data-coupon-code]');
        const codeText = codeEl ? codeEl.textContent.trim() : 'WELCOME15';

        if (navigator.clipboard) {
          navigator.clipboard.writeText(codeText);
        }

        const copyText = copyBtn.querySelector('.copy-text');
        const copiedText = copyBtn.querySelector('.copied-text');

        if (copyText && copiedText) {
          copyText.style.display = 'none';
          copiedText.style.display = 'inline';

          setTimeout(function() {
            copyText.style.display = 'inline';
            copiedText.style.display = 'none';
          }, 2500);
        }
      }
    });

    // Escape Key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        hidePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExitPopup);
  } else {
    initExitPopup();
  }
})();
